module.exports = __webpack_public_path__ + "static/Integrated-Data-Shaping-93c84a0d4c4bdc503bbf59b6dea4a751.png";